module.exports = __webpack_public_path__ + "img/c5201901-1.06674926.jpg";